module.exports = __webpack_public_path__ + "rank2.a5c281e7.png";